const SIZES = {
  nano: "nano",
  small: "small",
  medium: "medium",
  large: "large",
  viewport: "viewport",
};

export { SIZES };
